angular.module("cpayApp").requires.push('wu.masonry', 'as.sortable', 'ngImgCrop');
cpayApp
    .filter('filterMenu', () => {
        return _.memoize((inputArray, siftTerm) => {
            // a memoize function is imported from underscore.js and used here to
            // prevent angular from recurring a digest infinitely.
            var returnArray = [],
                menuSiftTerm = siftTerm.trim().toLowerCase();
            if (menuSiftTerm === '') {
                returnArray = inputArray;
            } else if (inputArray) {
                for (let group of inputArray) {
                    if (group.name.toLowerCase().indexOf(menuSiftTerm) !== -1) {
                        returnArray.push(group);
                    } else {
                        let matchFound = false,
                            newGroup = angular.copy(group);
                        newGroup.links = [];
                        for (let link of group.links) {
                            if (link.name.toLowerCase().indexOf(menuSiftTerm) !== -1) {
                                newGroup.links.push(link);
                                matchFound = true;
                            }
                        }
                        if (matchFound) returnArray.push(newGroup);
                    }
                }
            }
            return returnArray;
        }, (inputArray, siftTerm) => {
            var hash = siftTerm === '' ? '___blankSiftTerm___' : siftTerm;
            if (inputArray) {
                return inputArray.length + hash;
            } else return '0___blankSiftTerm___';
        });
    })
    .controller('headerCtrlr', ($scope, $http, $timeout, $window, $rootScope, CSRF_TOKEN) => {
        var userCopyForRevert;

        function headerResizing() {
            function headerHeight() {
                return $('#csv2-header-top').outerHeight(true) + $('#csv2-header-bottom').outerHeight(true);
            }

            $timeout(() => {
                $('#csv2-header-padding').height(headerHeight());
                $('#csv2-header-menu').height($($window).height() - headerHeight());
            });
        }

        function refreshSavedLinksCopy() {
            $scope.savedLinksCopy = [];
            /*
             * Why savedLinksCopy?
             *
             * user.navigation_settings is just an array of link IDs: e.g. ['1','2','3'].
             *
             * savedLinksCopy has ancilary information for each node.
             *
             * This information is necessary to build the list of links.
             * Everytime savedLinksCopy is changed (removedLink, addLink
             * or as-sortable itemMoved), user.navigation_settings should be made
             * to match (and saved to the cloud).
             *
             * savedLinksCopy is also compared to user.navigation_settings to
             * make sure that as-sortable.js doesn't accidentally remove a
             * link (a bug when using it and track by $index). (See
             * $scope.dragControl.)
             *
             * resulting savedLinksCopy sctructure:
             *   [
             *       {
             *           id: '1',
             *           name: 'Display Name',
             *           url: 'path/to/page',
             *           target: '_blank',
             *           new: false,
             *           kind: 'tools',
             *           savedLinksIndex: 0
             *               // (does not always == id or id - 1), because
             *               // some links could be in user.navigation_settings but
             *               // not displayed.
             *       },
             *       ...
             *   ]
             */
            $.each($scope.user.navigation_settings, (savedLinkIndex, savedLink) => {
                var linkFound = false;
                for (let group of $scope.links) {
                    for (let groupLink of group.links) {
                        if (groupLink.id === savedLink) {
                            $scope.savedLinksCopy.push(angular.copy(groupLink));
                            $scope.savedLinksCopy[$scope.savedLinksCopy.length - 1].kind = group.kind;
                            $scope.savedLinksCopy[$scope.savedLinksCopy.length - 1].savedLinksIndex = savedLinkIndex;
                            linkFound = true;
                        }
                        if (linkFound) break;
                    }
                    if (linkFound) break;
                }
            });
        }

        function saveUser(successFn, errorFn) {
            // Back-end should re-write this function.
            $http.post('/api/user/settings', $scope.user)
                .success(() => {
                    // toast a save confirmation

                    if ($('#user-saved-toast').length === 0) {
                        $('body').append('<div id="user-saved-toast">Toolbar links saved.</div>');
                        //console.log($scope.user);
                    }
                    $timeout(() => {
                        $('#user-saved-toast').fadeOut(3000, () => {
                            $('#user-saved-toast').remove();
                        })
                    }, 2000);
                    if (successFn) successFn();

                })
                .error(() => {
                    // try again? graceful fail?
                    if (errorFn) errorFn();
                });
        }

        function toggleHeaderMenu(doFocus) {
            $('#csv2-header-menu').slideToggle(200, () => {
                if ($('#csv2-header-menu').is(':visible')) {
                    $timeout(() => {
                        $rootScope.$broadcast('masonry.reload');
                    });
                    $('body').css({overflow: 'hidden'});
                    if (doFocus) $('#csv2-header-menu-sift').focus();
                } else {
                    $('#csv2-header-menu-sift').blur();
                    $('body').css({overflow: 'auto'});
                }
            });
        }

        function headerHotKeys(evt) {
            if (evt.which == 27 && $('#csv2-header-menu').is(':visible')) { // esc -> hide header menu
                toggleHeaderMenu();
                return false;
            } else if (evt.ctrlKey && evt.altKey) {
                switch (evt.which) {
                    case 32: // space -> toggle header menu
                        if ($('#csv2-header-menu').is(':visible')) {
                            if ($('#csv2-header-menu-sift').is(':focus')) {
                                toggleHeaderMenu();
                            } else $('#csv2-header-menu-sift').focus();
                        } else toggleHeaderMenu(true);
                        return false;
                        break;
                    case 83: // S --> header's search bar
                        $("#csv2-header-universal-search-bar").focus();
                        return false;
                        break;
                }
            }
        }

        $scope.universalSearchTerm = '';
        $scope.universalSearchCategories = [
            {label: 'Merchant (CPAY ID)', val: 'cpay_id'},
            {label: 'Merchant (MID)', val: 'mid'},
            {label: 'Merchant DBA', val: 'bname'},
            {label: 'Merchant Phone', val: 'phone'},
            {label: 'Merchant Email', val: 'email'},
            {label: 'Agent', val: 'agent'},
            // { label: 'Agent Name', val: 'agent_name' },
            {label: 'Ticket ID', val: 'ticket'}
        ];
        $scope.chosenUniversalSearchCategory = $scope.universalSearchCategories[2];
        $scope.menuSiftTerm = '';
        $scope.dragControl = {
            containment: '#csv2-header-bottom',
            accept: (sourceItemHandleScope, destSortableScope) => {
                return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
            }, // accept callback reverts the array when the user tries to drag between lists. This has not been tested.
            dragEnd: (evt) => {
                if ($scope.savedLinksCopy.length === $scope.user.navigation_settings.length - 1) {
                    // Error! A word got deleted by mistake! Restoring.
                    refreshSavedLinksCopy();
                }
            },
            orderChanged: () => {
                $timeout(() => {
                    $scope.user.navigation_settings = [];
                    $.each($scope.savedLinksCopy, (i, obj) => {
                        $scope.user.navigation_settings.push(obj.id);
                    });
                    refreshSavedLinksCopy(); // This is so that $scope.user.navigation_settings[n].savedLinksIndex
                    // is refreshed, and $scope.removeSavedLink(savedLinksIndex) still works.
                    saveUser();
                });
            }
        };
        $scope.catMenuShown = false;
        $scope.displayedAvatar = '/user/avatar';
        $scope.uploadedAvatar = '';
        $scope.uploadedAvatarCropped = '';
        $scope.avatarUploading = false;
        $scope.outputData = (data) => {
            console.log(data);
        }; // For testing.
        $scope.changeAvatar = (kind, genIndex) => {
            var logoData = new FormData();
            var tempAvatar;
            if (typeof kind !== 'undefined' && kind === 'generic' && typeof genIndex !== 'undefined' && $.isNumeric(genIndex)) {
                tempAvatar = $scope.stndAvatars[genIndex];
                logoData.append('genericlogo', tempAvatar);
            } else if (typeof kind !== 'undefined' && kind === 'upload') {
                tempAvatar = $scope.uploadedAvatarCropped;
                logoData.append('logo', tempAvatar);
            } else if (typeof kind !== 'undefined' && kind === 'indecisive') {
                tempAvatar = '/imgs/avatar-avatar.jpg';
                logoData.append('genericlogo', tempAvatar);
            }
            logoData.append('_method', 'PUT');
            logoData.append('_token', CSRF_TOKEN);

            $.ajax({
                url: '/upload/AvatarAsUserID',
                data: logoData,
                cache: false,
                contentType: false,
                processData: false,
                type: 'POST',
                success: function(response) {
                    $scope.displayedAvatar = tempAvatar;
                    $scope.user.pic = tempAvatar;
                    saveUser();
                },
                error: function(response) {
                    // failed action
                }
            });

        };
        $scope.onAvatarLoadBegin = () => {
            $scope.avatarUploading = true;
        };
        $scope.onAvatarLoadEnd = () => {
            $scope.avatarUploading = false;
        };
        var whatAreYouDoingCount = 0;
        $scope.whatAreYouDoing = () => {
            whatAreYouDoingCount++;
            if (whatAreYouDoingCount === 15) {
                whatAreYouDoingCount = 0;
                $scope.changeAvatar('indecisive');
            }
        };
        $scope.toggleHeaderMenu = (doFocus) => {
            toggleHeaderMenu(doFocus);
        };
        $scope.toggleCatMenu = () => {
            $scope.catMenuShown = $scope.catMenuShown ? false : true;
        };
        $scope.isChosenCat = (index) => {
            return $scope.chosenUniversalSearchCategory === $scope.universalSearchCategories[index]
                ? true
                : false;
        };
        $scope.chooseCat = (index) => {
            $scope.chosenUniversalSearchCategory = $scope.universalSearchCategories[index];
            $scope.catMenuShown = false;
        };
        $scope.doUniversalSearch = (evt) => {
            console.log("search!");
            var endpoint = '/redirect/centralstation/merchant_new/merchant_search_res.php',
                type = $scope.chosenUniversalSearchCategory.val,
                term = $scope.universalSearchTerm,
                url = endpoint + '?type=' + type + '&term=' + term;
            if (term === '') {
                modalCentral.openModal('no-universal-search-term');
            } else {
                 if (evt.ctrlKey || evt.metaKey) {
                     window.open(url);
                 } else {
                     window.location.href = (url);
                 }
            }
        };
        $scope.removeSavedLink = (index) => {
            $scope.user.navigation_settings.splice(index, 1);
            refreshSavedLinksCopy();
            saveUser();
            headerResizing();
        };
        $scope.addSavedLink = (id) => {
            if ($scope.user.navigation_settings.indexOf(id) == -1) {
                $scope.user.navigation_settings.push(id);
                refreshSavedLinksCopy();
                saveUser();
                headerResizing();
            }
        };
        $http.get('/api/user/settings').success((userResponse) => { // User JSON end point here.
            $scope.user = userResponse;

            $http.get('/json/standard-avatars.json').success((response) => {
                $scope.stndAvatars = response;
            });
            $http.get('/api/navigation/available')
                .success((linksResponse) => {
                    $scope.links = linksResponse;

                    refreshSavedLinksCopy();
                    $('body').prepend('<div id="csv2-header-padding"></div>');
                    headerResizing();
                    angular.element($window).on('resize', headerResizing);
                    $scope.$watch('menuSiftTerm', (newVal, oldVal) => {
                        if (newVal !== oldVal) $timeout(() => {
                            $rootScope.$broadcast('masonry.reload');
                        });
                    });
                })
                .error((error) => {
                    $scope.linksLoadFail = true;
                });
        }).error((error) => {
            $scope.linksLoadFail = true;
        });
        $(document).mouseup((e) => {
            if ($scope.catMenuShown && !$("#csv2-header-universal-search-categories-container").is(e.target) &&
                $("#csv2-header-universal-search-categories-container").has(e.target).length === 0) {
                $timeout(() => {
                    $scope.toggleCatMenu();
                });
            }
        });
        $(window).bind("keydown", headerHotKeys);
        $('#header-edit-avatar-choose-button').on('change', (evt) => {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();
            reader.onload = (evt) => {
                $scope.$apply(($scope) => {
                    $scope.uploadedAvatar = evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        });
    });
tabCentral.init($("#header-edit-avatar-container")[0], {headerClass: "standard-font"});
